<template>
<div class="chapter">
<div class="inner_page">
<p class="half"><a id="page_i"></a>NOTHING LEFT TO FEAR<br/>FROM HELL<a id="page_ii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// half.vue?cf9eda3a